import React from 'react';
import { YMInitializer } from 'react-yandex-metrika';
import ReactGA from 'react-ga';

import { YANDEX_METRIC_ID, GA_TRACKING_ID, USE_GA, USE_YA } from './utils/analytics';

import Header from './sections/Header';
import KeyFeatures from './sections/KeyFeatures';
import Questions from './sections/Questions';
import Footer from './sections/Footer';

import s from './App.module.css';

const EXPERT_REG_LINK = '/Account/RegisterExpert';

if (USE_GA) {
  ReactGA.initialize(GA_TRACKING_ID);
  ReactGA.plugin.require('ecommerce');
};

function App() {
  const handleBtnClick = () => {
    window.location.assign(EXPERT_REG_LINK);
  };

  return (
    <div className={s.layout}>
      <Header onBtnClick={handleBtnClick} />
      <KeyFeatures />
      <Questions />
      <Footer onBtnClick={handleBtnClick} />
      {USE_YA && <YMInitializer
        accounts={[YANDEX_METRIC_ID]}
        options={{
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          trackHash: true,
          ecommerce: 'dataLayer'
        }}
        version="2"
      />}
    </div>
  );
}

export default App;
